import { Box } from '@salecycle/ui-component-library';
import { useFeatureFlags, usePermissions } from 'core/app/AppContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import * as RecentClients from '../utils/recentClients';
import { AuthorisedClientListButton } from './AuthorisedClientListButton';
import { usePreferencesDispatch, toggleSearchOverlay } from 'core/preferences/usePreferencesContext';

interface IProps {
  level: string;
  id: string;
}

export const ClientListItemOptions: React.FC<IProps> = (props: IProps) => {
  const { t } = useTranslation();
  const { push } = useHistory();
  const { flagEnabled } = useFeatureFlags();
  const { hasPermission } = usePermissions();
  const dispatch = usePreferencesDispatch();

  const settingsPath = 'settings';
  const campaignsPath = 'campaigns';
  const designsPath = 'designs';
  const compliancePath = 'compliance';
  const isASite = props.level === 'sites';

  const listItemSettingsClickHandler = (event: React.MouseEvent) => {
    return handleListItemSelected(event, `/${props.level}/${props.id}/${settingsPath}`);
  };

  const listItemComplianceClickHandler = (event: React.MouseEvent) => {
    return handleListItemSelected(event, `/${props.level}/${props.id}/${compliancePath}`);
  };

  const listItemCampaignsClickHandler = (event: React.MouseEvent) => {
    return handleListItemSelected(event, `/${props.level}/${props.id}/${campaignsPath}`);
  };

  const listItemDesignsClickHandler = (event: React.MouseEvent) => {
    return handleListItemSelected(event, `/${props.level}/${props.id}/${designsPath}`);
  };

  const handleListItemSelected = (event: React.MouseEvent, path: string) => {
    toggleSearchOverlay(dispatch, false);
    RecentClients.addToLocalStorage(props.level, props.id);
    event.stopPropagation();
    return push(path);
  };
  return (
    <Box>
      <>
        {isASite ? (
          <AuthorisedClientListButton
            tooltipDescription={t('search.goToCampaigns')}
            featureFlags={[]}
            permissions={['ManageCampaigns']}
            icon="rocket"
            onClick={listItemCampaignsClickHandler}
            ariaLabel="Campaigns"
          />
        ) : null}
      </>
      <>
        {isASite ? (
          <>
            {hasPermission('ManageAssets') ? (
              <AuthorisedClientListButton
                tooltipDescription={t('search.goToDesigns')}
                permissions={['ManageAssets']}
                icon="paint-brush"
                onClick={listItemDesignsClickHandler}
                ariaLabel="Designs"
              />
            ) : (
              <AuthorisedClientListButton
                tooltipDescription={t('search.goToDesigns')}
                permissions={['ManageTemplates']}
                icon="paint-brush"
                onClick={listItemDesignsClickHandler}
                ariaLabel="Designs"
              />
            )}
          </>
        ) : null}
      </>
      <>
        {isASite && (flagEnabled('compliance-send-rules') || flagEnabled('compliance-consent-history')) ? (
          <AuthorisedClientListButton
            tooltipDescription={t('search.goToCompliance')}
            permissions={['ManageClients']}
            icon="check-circle"
            onClick={listItemComplianceClickHandler}
            ariaLabel="Compliance"
          />
        ) : null}
      </>
      <>
        <AuthorisedClientListButton
          tooltipDescription={t('search.goToSettings')}
          permissions={['ManageClients']}
          icon="cog"
          onClick={listItemSettingsClickHandler}
          ariaLabel="Settings"
        />
      </>
    </Box>
  );
};
